import {
  CANCEL_QUOTE,
  CANCEL_QUOTE_ERROR,
  CANCEL_QUOTE_SUCCESS,
  CLOSE_CANCEL_QUOTE_DIALOG,
  OPEN_CANCEL_QUOTE_DIALOG
} from './CancelQuoteDialog.actions'

const cancelQuoteDialogState = {
  error: false,
  loading: false,
  open: false
}

/**
 * The Cancell Quote Dialog' reducer.
 */
const cancelQuoteDialogReducer = (state = cancelQuoteDialogState, { type }) => {
  switch (type) {
    case CLOSE_CANCEL_QUOTE_DIALOG: {
      return { ...state, open: false }
    }
    case CANCEL_QUOTE: {
      return { ...state, error: false, loading: true }
    }
    case CANCEL_QUOTE_ERROR: {
      return { ...state, error: true, loading: false }
    }
    case CANCEL_QUOTE_SUCCESS: {
      return { ...state, error: false, loading: false, open: false }
    }
    case OPEN_CANCEL_QUOTE_DIALOG: {
      return { ...state, error: false, open: true }
    }
    default: {
      return state
    }
  }
}

export default cancelQuoteDialogReducer
